<template>
	<a
		v-if="campaignEnabled"
		:href="kitUrl"
		@click="trackClick"
		class="block w-full rounded-xl overflow-hidden bg-[#f7ecd8] dark:bg-[#2b3638] relative group shadow-lg border border-[#cc9d4f]/20"
		aria-label="Get the free Worship Together starter kit"
	>
		<!-- Aspect, not a fixed height: the aside is w-full below lg, so a fixed h-32
		     turned this into a 6:1 letterbox on tablet and cropped every face out.
		     The source has to match that aspect too -- object-cover'ing the 0.86:1
		     portrait crop into this 2.25:1 box was still a 2.6x zoom that sliced the
		     father's eyes off. wt-band-greeting is cut 9:4 with every face intact. -->
		<div class="relative aspect-[9/4] overflow-hidden">
			<img src="/images/wt-band-greeting.jpg" class="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" alt="" />
			<div class="absolute inset-0 bg-gradient-to-t from-[#f7ecd8] dark:from-[#2b3638] via-[#f7ecd8]/25 dark:via-[#2b3638]/25 to-transparent pointer-events-none" />
		</div>

		<div class="relative px-6 pb-6 -mt-8 flex flex-col items-center text-center">
			<img
				src="/images/wt-brand-logo.png"
				alt=""
				class="w-14 h-14 mb-3 object-contain drop-shadow"
			/>
			<div class="text-[10px] font-semibold uppercase tracking-[0.22em] text-[#cc9d4f] mb-2">
				We Worship Together
			</div>
			<div class="text-2xl font-serif font-bold leading-tight mb-2 text-[#334849] dark:text-gray-100">
				Worship together as a family.
			</div>
			<div class="text-sm text-[#5b544a] dark:text-gray-400 mb-5 max-w-xs leading-relaxed">
				A free starter kit to help you begin this Sunday.
			</div>
			<span
				class="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-[#4e6f70] text-white text-xs font-semibold tracking-wide shadow-lg transition-all group-hover:bg-[#41605f] group-hover:shadow-xl"
			>
				Get the free kit
				<i class="fas fa-arrow-right text-xs transition-transform group-hover:translate-x-0.5" />
			</span>
		</div>
	</a>
</template>

<script>
import createCampaignElementMixin from '../../helpers/campaignElementMixin'

const KIT_PATH = '/worship-together'
const UTM_BASE = 'utm_source=cfl-site&utm_medium=blog-sidebar&utm_campaign=worship-together'

export default {
	mixins: [createCampaignElementMixin('blog-sidebar-cta')],
	props: {
		postSlug: {
			type: String,
			default: '',
		},
	},
	computed: {
		utmContent() {
			return this.postSlug || 'blog-index'
		},
		kitUrl() {
			return `${KIT_PATH}?${UTM_BASE}&utm_content=${encodeURIComponent(this.utmContent)}`
		},
	},
	mounted() {
		if (this.campaignEnabled) this.trackCampaignImpression({ post_slug: this.postSlug || null })
	},
	watch: {
		campaignEnabled(v) {
			if (v) this.trackCampaignImpression({ post_slug: this.postSlug || null })
		},
	},
	methods: {
		trackClick() {
			this.trackCampaignClick({ post_slug: this.postSlug || null, link_url: this.kitUrl })
			try {
				if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
					window.gtag('event', 'family_worship_kit_sidebar_click', {
						event_category: 'engagement',
						event_label: 'blog-sidebar',
						post_slug: this.postSlug || null,
						link_url: this.kitUrl,
					})
				}
			} catch {}
		},
	},
}
</script>
